import questionnaire from './questionnaire';

export default {
	questionnaire
};
